import React from 'react';

class PhoneNumberUtils {
  israeliPhoneToInternation = (phoneNumber: string) => {
    // Remove all non-digit characters except the leading +
    const cleaned = phoneNumber.replace(/[^\d+]/g, '');

    // If it starts with +972, it's already in international format
    if (cleaned.startsWith('+972')) {
      return cleaned;
    }

    // If it starts with 972 (without +), add the +
    if (cleaned.startsWith('972')) {
      return '+' + cleaned;
    }

    // If it starts with 0 (Israeli local format), replace with +972
    if (cleaned.startsWith('0')) {
      return '+972' + cleaned.substring(1);
    }

    // If none of the above, assume it's missing the country code
    // and starts with the area code (like 52)
    return '+972' + cleaned;
  };

  internationalToIsraeli = (phoneNumber: string) => {
    // If input is null, undefined, or empty, return as is
    if (!phoneNumber) return phoneNumber;

    // Convert to string in case a number is passed
    const input = String(phoneNumber).trim();

    // Check if already formatted (contains " - ")
    if (input.includes(' - ')) {
      return input;
    }

    // Remove the '+972' country code and any spaces/dashes
    const cleaned = input.replace(/^\+972/, '').replace(/[\s-]/g, '');

    // If it starts with 0, remove it (we'll add it back)
    const withoutLeadingZero = cleaned.replace(/^0/, '');

    // Extract the prefix (first 2 digits) and the rest
    const prefix = withoutLeadingZero.substring(0, 2);
    const rest = withoutLeadingZero.substring(2);

    // Format as "0XX - XXXXXXX"
    return `0${prefix} - ${rest}`;
  };
}

const phoneNumberUtils = new PhoneNumberUtils();
export default phoneNumberUtils;

export const PhoneNumberComponent: React.FC<{ phoneNumber: string }> = ({
  phoneNumber,
}) => {
  return (
    <label style={{ direction: 'ltr', unicodeBidi: 'bidi-override' }}>
      {phoneNumberUtils.internationalToIsraeli(phoneNumber)}
    </label>
  );
};
